import React from 'react';
import { StanInput, StanModal } from '@/components';

interface DeleteAccountConfirmationModalProps {
    isOpen: boolean;
    confirmationText: string;
    deletingAccount: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onConfirmationTextChange: (text: string) => void;
}

export const DeleteAccountConfirmationModal: React.FC<DeleteAccountConfirmationModalProps> = ({
    isOpen,
    confirmationText,
    deletingAccount,
    onClose,
    onConfirm,
    onConfirmationTextChange,
}) => {
    return (
        <StanModal
            id='delete-stan-acct-modal'
            isOpen={isOpen}
            title='Permanently delete your Stan Store?'
            size='sm'
            onClose={onClose}
            primaryActionLabel='Permanently Delete My Account'
            primaryActionColor='destructive'
            primaryActionLoading={deletingAccount}
            primaryActionDisabled={confirmationText.trim().toUpperCase() !== 'DELETE' || deletingAccount}
            onPrimaryAction={onConfirm}
            footerNote={
                <p className='text-gray text-caption-1-regular -mt-6 pb-2 text-center font-semibold'>
                    Save any content you don&apos;t want to lose
                    <br />
                    before continuing.
                </p>
            }
        >
            <div className='space-y-4'>
                <p className='text-gray text-caption-1-regular text-center'>
                    Deletion takes up to 7 days. You won&apos;t have account access during this time. Change your mind?
                    Email{' '}
                    <a href='mailto:friends@stanwith.me' className='underline'>
                        friends@stanwith.me
                    </a>
                    .
                </p>
                <StanInput
                    name='deletion-word-confirmation'
                    placeholder="Please type 'DELETE' to confirm."
                    value={confirmationText}
                    onChange={e => onConfirmationTextChange(e.target.value.toUpperCase())}
                />
            </div>
        </StanModal>
    );
};
